export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'MontazDV';
export const NAME = 'MontazDV';
